import React, { useState, useCallback, useEffect } from "react";
import Quill from "quill";
import "quill/dist/quill.bubble.css";

export default function TextEditorReadOnly({
  value: propsValue,
  onChange: propsOnChange,
  content: propsContent,
  submit: propsOnSubmit,
  onClick: propsOnClick,
  className: propsClassName,
}) {
  const [quill, setQuill] = useState(null);

  const updateQuill = (quill, content) => {
    if (typeof content === "string") {
      if (content.startsWith("{")) {
        if (quill === null) return;
        quill.setContents(JSON.parse(content));
      } else {
        if (quill === null) return;
        quill.setText(content);
      }
    } else {
      quill.setContents(content);
    }
  };

  useEffect(() => {
    if (quill === null) return;
    updateQuill(quill, propsContent);
    // eslint-disable-next-line
  }, [propsContent]);

  const wrapperRef = useCallback((wrapper) => {
    if (wrapper === null) return;
    wrapperRef.innerHTML = "";
    const editor = document.createElement("div");
    wrapper.append(editor);
    const q = new Quill(editor, { toolbar: [], theme: "bubble" });
    setQuill(q);
    q.enable(false);
    updateQuill(q, propsContent);
    // eslint-disable-next-line
  }, []);
  return (
    <div
      id="QreadOnly"
      className={propsClassName}
      ref={wrapperRef}
      onClick={propsOnClick && propsOnClick}
    />
  );
}
